import styled, { css } from 'styled-components';

import { Wrapper as Grid } from 'Components/Grid/Grid.styled';
import { Wrapper as Col } from 'Components/Grid/Col/Col.styled';

import { LeftQuoteIcon, RightQuoteIcon } from 'Components/QuoteBlock/QuoteBlock.styled';

import PaginationComponent from 'Components/Pagination';

export const Background = styled.div`
    ${({ theme }) => css`
        background-color: var(--bg-color, ${theme.colors.primary.hex});
        overflow: hidden;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: -2;
        padding-bottom: 2rem;
    `}
`;

export const Heading = styled.h1`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        color: inherit;
        letter-spacing: 0.1rem;
        line-height: 0.9;
        margin: 0;
        margin-bottom: -0.2rem;
        font-weight: 300;
        font-size: 0.7rem;

        @media ${theme.breakpoints.smallLarge.media} {
            letter-spacing: 0.3rem;
            font-size: 0.9rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: absolute;
        top: -13.3rem;
        left: -10rem;
        width: 40.25rem;
        height: 250rem;
        z-index: -1;

        @media ${theme.breakpoints.smallLarge.media} {
            left: -10rem;
            width: 35rem;
            height: 190rem;
        }

        @media ${theme.breakpoints.large.media} {
            top: 0;
            left: calc(50% - 75rem);
            height: 431rem;
            width: 88.5rem;
        }
    `}
`;

export const ContentContainer = styled.div<{ $tabNavigation?: boolean }>`
    ${({ theme, $tabNavigation }) => css`
        position: relative;
        width: 100%;
        background-color: ${theme.colors.primaryContrast.hex};
        margin-top: 1rem;
        border-radius: 0.5rem;
        transform: translateZ(0);
        padding: 2rem 0.75rem;

        @media ${theme.breakpoints.large.media} {
            padding: 2rem 6.5rem;
        }

        & > ${Grid} > ${Col} > *:first-child,
        & > *:first-child {
            margin-top: 0;
        }

        ${LeftQuoteIcon} {
            opacity: 0.9;
        }
        ${RightQuoteIcon} {
            opacity: 0.9;
        }

        margin-bottom: ${$tabNavigation ? '1.5rem' : '0'};

        h2,
        h3 {
            font-family: ${theme.fonts.secondary};
            font-weight: 300;

            @media ${theme.breakpoints.large.media} {
                font-size: 3.5rem;
                line-height: 1;
                margin-bottom: 1rem;
            }
        }
    `}
`;

export const InfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Wrapper = styled.div`
    margin: 1rem 0;

    :first-of-type {
        margin-top: 0;
        p {
            margin-top: -0.5rem;
        }
    }
`;

export const ContentWrapper = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            padding-bottom: 4rem;
        }
    `}
`;

export const Container = styled.div`
    ${({ theme }) => css`
        padding: 3rem 0;
        position: relative;

        @media ${theme.breakpoints.large.media} {
            padding: 5.4rem 0;
        }
    `}
`;

export const ContentImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        height: 13rem;
        overflow: hidden;
        margin: 0 -0.75rem;

        @media ${theme.breakpoints.large.media} {
            margin: 0 -6.5rem;
        }
    `}
`;

export const KeyPointContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 1rem;
`;

export const PageNumber = styled.span`
    font-size: 0.9rem;
`;

export const Pagination = styled(PaginationComponent)`
    ${({ theme }) => css`
        background-color: ${theme.colors.primaryContrast.hex};
    `}
`;

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
`;
